var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeClimLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 301.5",
    style: {
      enableBackground: "new 0 0 1000 301.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1B3958;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#9E1F22;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#D82927;}\n\t.st3{fill:#E75425;}\n\t.st4{fill:#F27C2A;}\n\t.st5{fill:#FCC021;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.1,115.9h31.3l23.4,84.5c5.4,19.1,9.1,35.6,14.7,54.7h1c5.6-19.1,9.4-35.6,14.7-54.7l23.1-84.5h30.2 l-51.6,168h-35.1L254.1,115.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.3,115.9h100.3V141h-70.7V184h59.9v25.1h-59.9v49.7h73.3v25.1H412.3V115.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M531.2,200.5c0-55,34.1-87.7,76.3-87.7c20.9,0,37.5,10.1,48,21.3l-15.8,19.2c-8.6-8.6-18.5-14.6-31.6-14.6 c-27.1,0-46.6,23.1-46.6,60.8c0,38.3,17.9,61.6,45.9,61.6c14.8,0,26.2-6.9,35.6-17.3l15.8,18.7c-13.5,15.8-30.9,24.5-52.5,24.5 C564.4,287,531.2,256.1,531.2,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M742.6,118.9c0-10,7.7-16.8,18.1-16.8s18.1,6.8,18.1,16.8c0,9.8-7.7,16.8-18.1,16.8S742.6,128.6,742.6,118.9z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.9,
    y: 157.7,
    className: "st0",
    width: 29.4,
    height: 126.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.3,
    y: 112.8,
    className: "st0",
    width: 29.4,
    height: 171.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M803.1,157.7h24.1l2.2,17.2h0.8c10.6-11.2,22.7-20.3,38.4-20.3c18.3,0,28.8,8.4,34.6,22.6 c12-12.8,24.4-22.6,40.3-22.6c26.4,0,38.6,18.3,38.6,50.2v79.1h-29.4v-75.3c0-20.8-6.1-28.6-19.3-28.6c-7.9,0-16.5,5.1-26.2,15.7 v88.2h-29.4v-75.3c0-20.8-6.1-28.6-19.3-28.6c-7.7,0-16.5,5.1-26.2,15.7v88.2h-29.4V157.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47,189.5l4.4,4.5l23.9-23.5l-4.4-4.5c-13.3-13.8-19.8-31.8-19.5-49.7H18C17.6,143.8,27.9,169.8,47,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.4,116.2c0.3-17.6,7.2-35.1,20.7-48.4l0,0L48.5,44C29.2,63.2,18.3,88.8,18,116.2H51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.5,44l23.6,23.8l0.5-0.5c12.9-12.4,29.7-19.2,47.5-19.2l0-33.7c-26.8,0-52.2,10.4-71.4,29.3 C48.7,43.8,48.6,43.9,48.5,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M120.2,14.4l0,33.7l0,0c18.7,0,35.6,7.5,48,19.7L191.8,44C173.3,25.7,148.1,14.4,120.2,14.4L120.2,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M191.8,44l-23.6,23.8v0c12.5,12.3,20.4,29.4,20.8,48.4h33.4C222.1,88,210.4,62.5,191.8,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.4,116.2H189c0,0.4,0,0.8,0,1.3c0,18.2-6.9,35.4-19.6,48.5l-32.5,33.6V164c19.5-6.9,33.5-25.7,33.5-47.7 c0-27.9-22.5-50.6-50.2-50.6C92.5,65.6,70,88.3,70,116.2c0,22,14,40.8,33.5,47.7v118.4l89.9-92.9c18.7-19.4,29.1-44.9,29.1-72 C222.4,117.1,222.4,116.7,222.4,116.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeClimLogo);
export default __webpack_public_path__ + "static/media/VEClim-Logo.19c9e4888b94f6bbcb4a4082fd42f874.svg";
export { ForwardRef as ReactComponent };